import { useState } from "react";

import { CanvasAnnotation } from "types/imageAnnotations";

export function useImageUploader() {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [imageToAnnotate, setImageToAnnotate] = useState<string | null>(null);
  const [annotatedImage, setAnnotatedImage] = useState<File | null>(null);
  const [savedAnnotations, setSavedAnnotations] = useState<CanvasAnnotation[]>([]);
  const [annotations, setAnnotations] = useState<CanvasAnnotation[]>([]);

  const clearImageUploader = () => {
    setSelectedImage(null);
    setImageToAnnotate(null);
    setAnnotatedImage(null);
    setSavedAnnotations([]);
    setAnnotations([]);
  };

  return {
    selectedImage,
    setSelectedImage,
    imageToAnnotate,
    setImageToAnnotate,
    annotatedImage,
    setAnnotatedImage,
    savedAnnotations,
    setSavedAnnotations,
    annotations,
    setAnnotations,
    clearImageUploader
  };
}
